module.exports = function(data) {
var __t, __p = '', __e = _.escape;
__p += '<div class="legend-color" style="background-color: ' +
((__t = ( data.color )) == null ? '' : __t) +
';"></div>\n<div class="vertical">\n    <a href="#" class="drill-down-link row">\n        <div class="name" title="' +
__e( data.title ) +
'">' +
((__t = ( data.title )) == null ? '' : __t) +
'</div>\n        <div class="value">' +
((__t = ( data.value )) == null ? '' : __t) +
'&nbsp;<span class="distribution">(' +
((__t = ( data.percentage )) == null ? '' : __t) +
')</span></div>\n    </a>\n</div>\n<div class="horizontal">\n    <a href="#" class="drill-down-link clearfix">\n        <div class="col-xs-3 percentage">' +
((__t = ( data.percentage )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-9 name-cont">\n            <div class="name" title="' +
__e( data.title ) +
'">' +
__e( data.title ) +
'</div>\n            <div class="value">' +
((__t = ( data.value )) == null ? '' : __t) +
'</div>\n        </div>\n    </a>\n</div>\n';
return __p
}